import { render, staticRenderFns } from "./WeetControlPastille.vue?vue&type=template&id=66a4594e&scoped=true"
import script from "./WeetControlPastille.vue?vue&type=script&lang=ts"
export * from "./WeetControlPastille.vue?vue&type=script&lang=ts"
import style0 from "./WeetControlPastille.vue?vue&type=style&index=0&id=66a4594e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66a4594e",
  null
  
)

export default component.exports